import React, { useState } from 'react';
import Modal from 'react-responsive-modal';
import { Message, MessageResponse } from '../Message';
import { updateCabinetSuccess } from '../../Configurator/actions/furniture';
import { createStructuredSelector } from 'reselect';
import { RootState } from '../types';
import {
  makeSelectFurniture,
  makeSelectSelectedIdCabinet,
} from '../../Configurator/selectors/furniture';
import { Furniture } from '../../../lib/modelBuilder/entities/Furniture';
import { useDispatch, useSelector } from 'react-redux';
import ModalCancelButton from '../../../components/styles/ModalCancelButton';
import ModalConfirmButton from '../../../components/styles/ModalConfirmButton';
import ModalResponseButton from '../../../components/styles/ModalResponseButton';
import Img from '../../../components/Img';
import { useTranslation } from 'react-i18next';

interface StateProps {
  furniture: Furniture | null;
  selectedIdCabinet: string | null;
}
const stateSelector = createStructuredSelector<RootState, StateProps>({
  furniture: makeSelectFurniture(),
  selectedIdCabinet: makeSelectSelectedIdCabinet(),
});

interface Props {
  message: Message;
}

const MessageModal = ({ message }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { selectedIdCabinet, furniture } = useSelector(stateSelector);
  const [isOpen, setOpen] = useState(true);

  const closeModal = () => {
    setOpen(false);
  };

  const onClose = () => {
    closeModal();
  };

  const undoResponse: MessageResponse | undefined = message.responses?.find(
    e => e.undo === true,
  );

  const otherResponses:
    | MessageResponse[]
    | undefined = message.responses?.filter(e => e.undo !== true);

  function handleResponse(response: MessageResponse) {
    if (response.cabinet && selectedIdCabinet !== null && furniture !== null) {
      furniture.replace(response.cabinet, selectedIdCabinet);
      dispatch(updateCabinetSuccess(furniture, selectedIdCabinet));
    }
  }

  function handleUndo() {
    if (undoResponse) handleResponse(undoResponse);
  }

  return (
    <div>
      <Modal
        open={isOpen}
        onClose={onClose}
        center
        closeOnOverlayClick={false}
        showCloseIcon={false}
        closeOnEsc={false}
      >
        <div className="flex items-center justify-center">
          {message.image && (
            <div className="p-0">
              <Img
                src={message.image}
                alt="confirmation image"
                className="h-32 w-80"
              />
            </div>
          )}
          <div className="ml-4">
            <div className="my-4 mx-2">{message.message}</div>

            {otherResponses && otherResponses.length > 0 ? (
              <div className="flex flex-col items-start">
                {!message.noOK && (
                  <ModalConfirmButton onClick={onClose}>
                    {t('OK')}
                  </ModalConfirmButton>
                )}
                {otherResponses.map(response => (
                  <ModalResponseButton onClick={() => handleResponse(response)}>
                    {response.content}
                  </ModalResponseButton>
                ))}
                {undoResponse && (
                  <ModalCancelButton onClick={handleUndo}>
                    {undoResponse.content}
                  </ModalCancelButton>
                )}
              </div>
            ) : (
              <div className="flex justify-end">
                <div className="mx-2">
                  {undoResponse && (
                    <ModalCancelButton onClick={handleUndo}>
                      {undoResponse.content}
                    </ModalCancelButton>
                  )}

                  <ModalConfirmButton onClick={onClose}>
                    {t('OK')}
                  </ModalConfirmButton>
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default MessageModal;
